export default __webpack_public_path__ + "static/media/gupsuStart.e4dc53a1.svg";